import { type Module } from '@courses/types-layer/types/module'
import { type Post as Lesson } from '@courses/types-layer/types/post'

import { BaseService } from '@common/http-layer/service/base.service'
import { useLocation } from '@common/location-layer/composables/useLocation'

export class ModulesService extends BaseService {
  constructor() {
    super({
      baseURL: 'REST_API_URLS',
      basePath: '',
      headers: {
        version: '2021-07-28',
      },
    })
  }

  private endpoint(path: string = '', courseId: string, locationId?: string): string {
    const { store: state } = useLocation()
    if (!state.locationId) throw new Error('Location ID is required')
    return `/courses/learners/locations/${locationId ? locationId : state.locationId}/courses/${courseId}/modules${path}`
  }

  async findAll(
    courseId: string,
    courseLocationId: string
  ): Promise<{ modules: Array<Module>; totalModules: number }> {
    return await this.get<{ modules: Array<Module>; totalModules: number }>(
      this.endpoint('', courseId, courseLocationId),
      {
        locationId: courseLocationId,
        productId: courseId,
      }
    )
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error in findAll modules', error)
        return { modules: [], totalModules: 0 }
      })
  }

  async findNextModule(courseId: string, courseLocationId: string, moduleId: string): Promise<any> {
    return await this.get<any>(this.endpoint(`/${moduleId}`, courseId, courseLocationId), {
      locationId: courseLocationId,
      productId: courseId,
    })
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error in findNextModule', error)
        return {} as any
      })
  }

  async findModuleLessons(
    courseId: string,
    courseLocationId: string,
    moduleId: string
  ): Promise<{ lessons: Lesson[]; totalLessons: number }> {
    return await this.get<{ lessons: Lesson[]; totalLessons: number }>(
      this.endpoint(`/${moduleId}/lessons`, courseId, courseLocationId),
      {
        locationId: courseLocationId,
        productId: courseId,
      }
    )
      .then((res) => res.data)
      .catch((error) => {
        console.error('Error in findModuleLessons', error)
        return { lessons: [], totalLessons: 0 }
      })
  }
}
